export const isTaskDisabled = (el, ProjectDetails, type, userDetails) => {
  if (ProjectDetails?.is_archived) return true;

  const isAnnotator = ProjectDetails?.annotators?.some(
    (a) => a.id === userDetails?.id
  );

  if (type === "annotation" && isAnnotator) {
    if (ProjectDetails?.project_mode === "Annotation") {
      return el.annotation_status === "labeled";
    }
  }

  return false;
};

export const getTaskLink = (el,ProjectDetails,userDetails,type) => {
  if (ProjectDetails?.project_type?.includes("Acoustic")) {
    return `AudioTranscriptionLandingPage/${el.id}`;
  }

  const isAnnotator = ProjectDetails?.annotators?.some(
    (a) => a.id === userDetails?.id
  );

  if (type === "annotation" && isAnnotator) {
    if (ProjectDetails?.project_mode === "Annotation") {
      return el.annotation_status === "labeled" ? null : `task/${el.id}`;
    } else {
      return `task/${el.id}`;
    }
  }

  return `task/${el.id}`;
};